import { createContext, useContext } from "react";
import { GroupEditorController } from "./groupEditorController";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const GroupEditorControllerContext = createContext<GroupEditorController>(null as any);
export const useGroupEditorController = (): GroupEditorController => useContext(GroupEditorControllerContext);
